import { render, staticRenderFns } from "./headFeeDetailPriceEach.vue?vue&type=template&id=2d768d2d&scoped=true"
import script from "./headFeeDetailPriceEach.vue?vue&type=script&lang=js"
export * from "./headFeeDetailPriceEach.vue?vue&type=script&lang=js"
import style0 from "./headFeeDetailPriceEach.vue?vue&type=style&index=0&id=2d768d2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d768d2d",
  null
  
)

export default component.exports